import type { Cookies } from '~/types/cookies'

export function useGtmCookies() {
    const getCookies = useCookie<Cookies>('cookie_consent_preference')

    const COOKIE_INIT_EVENT = 'Cookie Consent Init'
    const COOKIE_UPDATE_EVENT = 'Cookie Consent Update'

    const sendGTMEvent = (event: typeof COOKIE_INIT_EVENT | typeof COOKIE_UPDATE_EVENT, cookies: Cookies) => {
        useGtm()?.trackEvent({
            event,
            ...cookies,
        })
    }

    if (getCookies.value) {
        sendGTMEvent(COOKIE_INIT_EVENT, getCookies.value)
    }

    document.addEventListener('cookie-consent:update', (event: Event) => {
        sendGTMEvent(COOKIE_UPDATE_EVENT, (<CustomEvent>event).detail.cookieConsentObject)
    })
}
